export default "/fonts/Ubuntu-Regular.woff2?f0c95172522d9ce0e1791439f6eb8ae2";